import React, { useState } from 'react';
import './ManageSubscriptionsPage.scss';
import { ContainerInner } from '../../shared/common/ContainerInner';
import { LoadingWrapper } from '../../shared/components/LoadingWrapper';
import LoadingOverlay from '../../shared/components/LoadingOverlay';
import DocumentTitle from '../../shared/components/DocumentTitle';
import { ProductEntry } from '../../store/api';
import { ManageSubscriptionsTableHeader } from './table/ManageSubscriptionsTableHeader';
import { AddCopyPopup } from './AddCopyPopup';
import { useManageSubscriptionsTableData } from './useManageSubscriptionsTableData';
import { ManageSubscriptionsHeader } from './ManageSubscriptionsHeader';
import { ManageSubscriptionsTableBody } from './table/ManageSubscriptionsTableBody';
import { usePaginationAndSortParams } from '../../shared/hooks/usePaginationAndSortParams';
import { ShowAllContextProvider } from '../../shared/subscription-management/ShowAllContext';
import { Pagination } from '../../shared/common/Pagination';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { ConfirmExpireIssuesDialog } from './ConfirmExpireIssuesDialog';

export const ManageSubscriptionsPage = () => {
    const { t } = useTranslation();
    const [selectedSubscription, setSelectedSubscription] = useState<ProductEntry | null>(null);
    const [expireIssuesEntry, setExpireIssuesEntry] = useState<ProductEntry | null>(null);

    const { page, pageSize } = usePaginationAndSortParams({ defaultPageSize: 50 });

    const { tableHeader, tableBody, subscriptionCount, isLoading } = useManageSubscriptionsTableData({
        pageSize,
        page,
        onAddCopy: (item: ProductEntry) => setSelectedSubscription(item),
        onExpireIssues: (item: ProductEntry) => setExpireIssuesEntry(item)
    });

    return (
        <>
            <DocumentTitle title={t('components.documentTitle.subscriptionManagement')}>
                {isLoading ? (
                    <ContainerInner>
                        <LoadingWrapper>
                            <LoadingOverlay loading={isLoading} />
                        </LoadingWrapper>
                    </ContainerInner>
                ) : null}
                <div className={classNames({ 'min-h-screen': isLoading }, 'manage-subscriptions-page')}>
                    <ManageSubscriptionsHeader pageSize={pageSize} subscriptionCount={subscriptionCount} />

                    <table className="manage-subscriptions-table">
                        {tableHeader && tableBody ? (
                            <ShowAllContextProvider>
                                <ManageSubscriptionsTableHeader {...tableHeader} />
                                <ManageSubscriptionsTableBody {...tableBody} />
                            </ShowAllContextProvider>
                        ) : null}
                    </table>

                    <Pagination pageSize={pageSize} totalItems={subscriptionCount} />
                </div>
            </DocumentTitle>

            {selectedSubscription && !isLoading ? (
                <AddCopyPopup hidePopup={() => setSelectedSubscription(null)} product={selectedSubscription.product} />
            ) : null}

            {expireIssuesEntry && !isLoading ? (
                <ConfirmExpireIssuesDialog
                    hidePopup={() => setExpireIssuesEntry(null)}
                    product={expireIssuesEntry.product}
                />
            ) : null}
        </>
    );
};
